import CreateModule from "./create";
import JoinModule from "./join";
import RoomModule from "./room";
import RoomsModule from "./rooms";

export default {
  CreateModule,
  JoinModule,
  RoomModule,
  RoomsModule,
};
